import PaymentUnavailable from '../../components/PaymentUnavailable';
export default function PaymentPending(){return <PaymentUnavailable context="payment pending route"/>}
